module.exports = __webpack_public_path__ + "static/media/story-30.ae992aa3.png";